import { getConf } from '@configuratorware/configurator-frontendgui/App/configuration';

const MM_PER_INCH = 25.4;

/** Default canvas when no design area is configured (3 m × 2 m). */
export const DEFAULT_CANVAS_WIDTH_MM = 3000;
export const DEFAULT_CANVAS_HEIGHT_MM = 2000;

/** Minimum world-space extent for tiny geometry (1 cm). */
export const MIN_WORLD_UNIT_MM = 10;

export type CanvasSize = {
  width: number;
  height: number;
  isMetric?: boolean;
  dpi?: number;
};

export function getDesignerDpi(): number {
  return getConf('designer.dpi', 300) as number;
}

/** Core configurator metric canvas sizes are already millimeters; pixel sizes convert via DPI. */
export function normalizeCanvasSize(canvasSize: CanvasSize): CanvasSize {
  const dpi = canvasSize.dpi || getDesignerDpi();
  const width = canvasSize.width || 0;
  const height = canvasSize.height || 0;

  if (canvasSize.isMetric) {
    return { ...canvasSize, width, height };
  }

  if (width > 0 && height > 0) {
    return {
      ...canvasSize,
      width: pxToMm(width, dpi),
      height: pxToMm(height, dpi),
    };
  }

  return canvasSize;
}

export function cmToMm(cm: number): number {
  return cm * 10;
}

export function mmToCm(mm: number): number {
  return Math.round(mm * 10) / 100;
}

export function pxToMm(px: number, dpi = getDesignerDpi()): number {
  return (px / dpi) * MM_PER_INCH;
}

export function formatHexColor(hex: string): string {
  if (!hex) return '#000000';
  const cleaned = hex.replace(/^#/, '');
  return `#${cleaned}`;
}
